import React from 'react';
import { SharedLink } from '@/types';
import { LinkItem } from '../LinkItem';

interface LinkListProps {
  links: SharedLink[];
  isAdmin: boolean;
  newLinkId: string | null;
  copiedLinkId: string | null;
  onToggleStatus: (linkId: string, currentStatus: boolean) => void;
  onDelete: (linkId: string) => void;
  onCopy: (link: SharedLink) => void;
}

export function LinkList({
  links,
  isAdmin,
  newLinkId,
  copiedLinkId,
  onToggleStatus,
  onDelete,
  onCopy,
}: LinkListProps) {
  if (links.length === 0) {
    return <p className="p-4 text-gray-500 text-center">لا توجد روابط مشتركة</p>;
  }

  return (
    <>
      {links.map((link) => (
        <LinkItem
          key={link.id}
          link={link}
          isAdmin={isAdmin}
          isNew={link.id === newLinkId}
          onToggleStatus={() => onToggleStatus(link.id, link.isActive)}
          onDelete={() => onDelete(link.id)}
          onCopy={() => onCopy(link)}
          copiedLinkId={copiedLinkId}
        />
      ))}
    </>
  );
}